import {
  ProHistoryFixtureLayout,
  loaderFn,
} from '@sorare/gameplay/src/layouts/ProHistoryFixtureLayout';

import { PageParams } from './__generated__/routeParams';

export const loader = loaderFn<PageParams>();

const NBAHistoryFixtureLayout = () => {
  return <ProHistoryFixtureLayout<PageParams> />;
};
export default NBAHistoryFixtureLayout;
